import React, { useEffect, useState } from 'react';
import './About.css';
import { Link } from 'react-router-dom';


const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // تأثيرات scroll بديلة عن AOS
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const elements = document.querySelectorAll('[data-fade]');
      
      elements.forEach(element => {
        const elementTop = element.offsetTop;
        const elementVisible = 150;
        
        if (scrollTop > elementTop - window.innerHeight + elementVisible) {
          element.classList.add('fade-in');
        }
      });

      // زر الانتقال للأعلى
      const goToTop = document.getElementById('goToTop');
      if (scrollTop > 300) {
        goToTop?.classList.add('active');
        setIsVisible(true);
      } else {
        goToTop?.classList.remove('active');
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // تشغيل مرة أولى

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    const button = e.currentTarget;
    button.classList.add('clicked');
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      button.classList.remove('clicked');
    }, 300);
  };

  // دالة بديلة عن react-helmet
  useEffect(() => {
    document.title = "About Us - Realm of Herbs";
    
    // إضافة styles مباشرة
    const style = document.createElement('style');
    style.innerHTML = `
      .go-to-top.clicked {
        animation: clickPulse 0.3s ease-out;
      }

      @keyframes clickPulse {
        0% { transform: scale(1); }
        50% { transform: scale(0.9); }
        100% { transform: scale(1); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>

      {/* Hero Section */}
      <section className="page-hero">
        <div className="hero-content">
          <h1 data-fade>About Our Company</h1>
          <p data-fade data-delay="100">
            Learn more about our journey, mission, and values
          </p>
        </div>
      </section>

      {/* Main About Section */}
      <section className="about-main">
        <div className="container">
          <div className="about-grid">
            <div className="about-image" data-fade>
              <a href="https://ibb.co/6ckXZFJt"><img src="https://i.ibb.co/4wH1fpgS/about-main.jpg" alt="about-main" border="0" /></a>
            </div>
            <div className="about-text" data-fade>
              <h2>Our Story</h2>
              <p>
                At Realm Of Herbs, we take pride in being one of the most prominent companies in the field of exporting high-quality medicinal herbs, legumes, spices, and seeds. With several years of experience, we have built an excellent reputation in global markets for our premium products, professional service, and commitment to customer satisfaction.
              </p>
              <p>
                We specialize in a wide range of medicinal herbs such as basil, peppermint, thyme, oregano, anise, fennel, and many others. Every product is carefully cultivated, harvested, and processed to preserve its natural aroma, flavor, and health benefits.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="mission-bg-pattern"></div>
        <div className="container">
          <div className="mission-header" data-fade>
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-intro">
              At Realm of Herbs, our mission is to meet the needs of our international clients by providing superior quality products that meet strict global standards, competitive prices without compromising quality, and sustainable practices ensuring eco-friendly farming and processing methods.
            </p>
          </div>
          
          <div className="mission-cards" data-fade>
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-seedling"></i>
              </div>
              <div className="mission-card-content">
                <h3>Premium Sourcing</h3>
                <p>We source the finest herbs, spices, and natural products from around the world, working directly with farmers who share our values.</p>
              </div>
            </div>
            
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-globe-americas"></i>
              </div>
              <div className="mission-card-content">
                <h3>Sustainable Practices</h3>
                <p>We support sustainable farming practices and fair trade, ensuring our business has a positive impact on communities and ecosystems.</p>
              </div>
            </div>
            
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <div className="mission-card-content">
                <h3>Education & Awareness</h3>
                <p>We educate our customers about the benefits and uses of natural ingredients, empowering them to make informed choices for their health.</p>
              </div>
            </div>
            
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <div className="mission-card-content">
                <h3>Exceptional Service</h3>
                <p>We provide exceptional customer service and product knowledge, building lasting relationships based on trust and satisfaction.</p>
              </div>
            </div>
            
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-heart"></i>
              </div>
              <div className="mission-card-content">
                <h3>Community Impact</h3>
                <p>We contribute to community health and well-being through our products, partnerships, and educational initiatives.</p>
              </div>
            </div>
            
            <div className="mission-card" data-fade>
              <div className="mission-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <div className="mission-card-content">
                <h3>Organic Excellence</h3>
                <p>We are committed to organic farming principles and practices, ensuring our products are free from harmful chemicals and pesticides.</p>
              </div>
            </div>
          </div>
          
          <div className="mission-cta" data-fade>
            <p>Join us in our mission to bring the best of nature to your table.</p>
            <Link to="/contact" className="btn-primary">Get in Touch</Link>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title" data-fade>Our Values</h2>
          <div className="values-grid" data-fade>
            <div className="value-card">
              <i className="fas fa-leaf"></i>
              <h3>Quality</h3>
              <p>We never compromise on the quality of our products, sourcing only the finest ingredients.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-globe-americas"></i>
              <h3>Sustainability</h3>
              <p>We are committed to environmentally friendly practices throughout our supply chain.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-handshake"></i>
              <h3>Integrity</h3>
              <p>We conduct our business with honesty, transparency, and respect for all stakeholders.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-heart"></i>
              <h3>Community</h3>
              <p>We believe in giving back to the communities that support us and our suppliers.</p>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default About;